import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
} from '@backstage/core-plugin-api';

import { awsDashboardApiRef, AwsDashboardClient } from './api';
import { accountmapRouteRef, pendingAccountRouteRef } from './routes';

export const awsDashboardPlugin = createPlugin({
  id: 'aws-dashboard', // 'aws'
  apis: [
    createApiFactory({
      api: awsDashboardApiRef,
      deps: {
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
      },
      factory: ({ configApi, discoveryApi }) =>
        AwsDashboardClient.fromConfig({ configApi, discoveryApi }),
    }),
  ],
  routes: {
    accountmap: accountmapRouteRef,
    pendingAccountDetail: pendingAccountRouteRef,
  },
});

export const AwsDashboardPage = awsDashboardPlugin.provide(
  createRoutableExtension({
    name: 'aws-dashboard',
    component: () =>
      import('./components/AwsDashboard').then(m => m.AwsDashboard),
    mountPoint: accountmapRouteRef,
  }),
);

export const AwsDashboardPendingAccountPage = awsDashboardPlugin.provide(
  createRoutableExtension({
    name: 'aws-dashboard-pending-account',
    component: () =>
      import('./components/AwsDashboardPendingAccount').then(
        m => m.AwsDashboardPendingAccount,
      ),
    mountPoint: pendingAccountRouteRef,
  }),
);
